import { Controller } from "@hotwired/stimulus"

// Makes a non-anchor row navigate like a link, while still letting nested
// real anchors and buttons be clicked normally. This lets us avoid invalid
// nested <a> markup in list rows that need both row-click navigation and
// inline action buttons.
export default class extends Controller {
  static values = { href: String }

  connect() {
    this.element.style.cursor = "pointer"
  }

  go(event) {
    if (this.shouldIgnore(event)) return
    if (!this.hasHrefValue) return

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
      window.open(this.hrefValue, "_blank", "noopener")
    } else {
      window.location.href = this.hrefValue
    }
  }

  stop(event) {
    event.stopPropagation()
  }

  shouldIgnore(event) {
    return event.target.closest("a, button, input, select, textarea, label, form")
  }
}
